import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { SiteProvider } from "./context/SiteContext";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { MobileActionBar } from "./components/MobileActionBar";

import Home from "./pages/Home";
import Mats from "./pages/Mats";
import ProductDetail from "./pages/ProductDetail";
import WallPads from "./pages/WallPads";
import CustomSolutions from "./pages/CustomSolutions";
import Installations from "./pages/Installations";
import About from "./pages/About";
import Resources from "./pages/Resources";
import Article from "./pages/Article";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PublicLayout = () => (
  <>
    <Nav />
    <main className="pt-[76px] lg:pt-[88px]">
      <Outlet />
    </main>
    <Footer />
    <div className="h-14 sm:hidden" aria-hidden="true" />
    <MobileActionBar />
  </>
);

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/mats" element={<Mats />} />
            <Route path="/mats/:slug" element={<ProductDetail />} />
            <Route path="/wall-pads" element={<WallPads />} />
            <Route path="/custom-solutions" element={<CustomSolutions />} />
            <Route path="/installations" element={<Installations />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
